<template>
  <div>
    <el-form style="margin-right: 20px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="addEditForm.name"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="addEditForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="短号" prop="om">
        <el-input v-model="addEditForm.om"></el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-row style="margin: 0 100px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeOpen()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addEditListPhone',
  model: {
    prop: 'addEditShow1',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addEditForm: {
        name: '',
        phone: '',
        om: ''
      },
      addEditRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        om: [
          { required: true, message: '请输入短号', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    closeOpen () {
      this.$emit('change', false)
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/addEditListPhone.vue